import { IconProps } from './IconProps';
export function PhoneFrameChatBubbleTip(props: IconProps) {
    return (
        <svg
            width="24"
            height="23"
            {...props}
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.2666 0.8125V21.9297C4.80017 21.9297 8.04082 20.6741 10.5654 18.584C13.084 20.2616 17.1214 21.8577 22 20.9707C20.6562 20.3948 15.4731 16.9385 15.665 10.0273C15.6422 10.0587 15.6165 10.0882 15.5918 10.1182C15.7652 9.21866 15.8574 8.28998 15.8574 7.33984V0.8125H1.2666Z"
                fill="currentColor"
            />
        </svg>
    );
}
